import { useTenant } from "@/app/Organisations/Hooks/useTenant";
import { ReactNode } from "react";
import { Badge } from "@/components/catalyst/badge";
import { cn } from "@/lib/utils";

export function AdminSection({
  children,
  className,
  containerClassName,
}: {
  children: ReactNode;
  className?: string;
  containerClassName?: string;
}) {
  const { isAdmin } = useTenant();

  if (!isAdmin) return null;

  return (
    <div
      className={cn(
        "relative overflow-hidden rounded-lg border border-gray-300",
        containerClassName,
      )}
    >
      {/* Diagonal stripes background */}
      <div
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: `repeating-linear-gradient(
                45deg,
                #f9fafb,
                #f9fafb 10px,
                #f3f4f6 10px,
                #f3f4f6 20px
              )`,
          opacity: 0.8,
        }}
      />
      <div className="relative z-10 p-4">
        <div className="flex justify-end pb-2">
          <Badge color="sky">Admin</Badge>
        </div>

        <div className={className}>{children}</div>
      </div>
    </div>
  );
}
